import { APP_INITIALIZER, enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { Environment } from './environments/environment';
import { AuthService, pcpPrimeNgConfig } from 'shared';
import { bootstrapApplication, BrowserModule, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { AppComponent } from '@portal/app.component';
import { provideRouter } from '@angular/router';
import { routes } from '@portal/app.routes';
import { BreadcrumbModule } from 'shared';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { PCPCommonModule } from 'shared';
import { MyUserProfileModule } from 'shared';
import { ModalModule } from 'shared';
import { SpinnerModule } from 'shared';
import { APP_BASE_HREF } from '@angular/common';
import { HammerConfig } from 'shared';
import { providePrimeNG } from 'primeng/config';

if (Environment.target === "environmentProd.target") {
	enableProdMode();
}

const appInitializer = (authService: AuthService) => {
	return () => authService.initialize();
};

export function oAuthModuleConfigFactory(apiUrl: string) {
	return {
		resourceServer:
		{
			allowedUrls: [apiUrl], //URL of your API
			sendAccessToken: true
		}
	};
}

bootstrapApplication(AppComponent, {
	providers: [
		provideRouter(routes),
		importProvidersFrom(
			BreadcrumbModule,
			BrowserModule,
			BrowserAnimationsModule,
			HammerModule,
			PCPCommonModule.forRoot(Environment.apiRoot, Environment.appInsights.instrumentationKey, Environment.authConfig, Environment.pcpUrl, Environment.storage, Environment.target),
			MyUserProfileModule,
			ModalModule,
			SpinnerModule),
		{ provide: APP_BASE_HREF, "useValue": "/portal/" },
		{ provide: HAMMER_GESTURE_CONFIG, "useClass": HammerConfig },
		{ provide: APP_INITIALIZER, useFactory: appInitializer, deps: [AuthService], multi: true },
		provideAnimations(),
        providePrimeNG(pcpPrimeNgConfig)
	]
})
	.catch((err) => console.error(err));